export enum OrgType {
  Private = 'Private Person',
  Corporate = 'Corporate',
}

export enum OrgGrade {
  A = 'Class A',
  B = 'Class B',
  C = 'Class C',
  D = 'Class D',
  G = 'Class G',
}
